import _ from 'lodash';
import i18n from '../i18n';
import { getCacheField } from '../tools/get-cache-field';
import { WebsocketClient } from '../websocket/module';

/**
 * 检查多个地址地址是否在餐馆的配送范围内
 * @restaurant 餐馆
 * @address 多个地址
 */
export async function checkAddress(restaurant: GoogleMapRestaurant, address: UserAddress[]) {
    // init
    let qualified: UserAddress[] = [];   // 匹配上的
    let failed: UserAddress[] = [];      // 没有匹配上的
    let result: UserAddress[] = [];
    try {
        // 餐厅的信息地址
        const { google_map_lat, google_map_lng, setting_level_delivery_distance } = restaurant;
        for (let item of address) {
            // 地址的经纬度
            let addressGoogleMapLat = Number(item.google_map_lat);
            let addressGoogleMapLng = Number(item.google_map_lng);
            // 餐厅与地址的距离
            let line = computeDistanceBetween({
                lat: Number(google_map_lat),
                lng: Number(google_map_lng)
            }, {
                lat: addressGoogleMapLat,
                lng: addressGoogleMapLng
            });
            // 在范围内 - 两点距离小于等于所设置的范围
            if (setting_level_delivery_distance === undefined) {
                qualified.push({ ...item, line });
            } else if (line <= (setting_level_delivery_distance || 0) / 1000) {
                qualified.push({ ...item, line });
            } else {
                failed.push({ ...item, line });
            }
        }
        failed.map((v) => {
            return v.isWithin = false;
        });
        qualified.map((v) => {
            return v.isWithin = true;
        });
        result = _.concat(qualified, failed)
    } catch (error) {
        console.log(error, '----error');
        address.map((v) => {
            v.isWithin = false
            v.line = undefined
            return v
        });
        result = address;
    }
    return result
}

/**
 * 计算直线距离
 * @param startCoordinates 开始位置的经纬度
 * @param endCoordinates 结束位置的经纬度
 * @returns 单位：千米
 */
export function computeDistanceBetween(startCoordinates: coordinates, endCoordinates: coordinates) {
    let latitudeFrom = startCoordinates.lat;
    let longitudeFrom = startCoordinates.lng;
    let latitudeTo = endCoordinates.lat;
    let longitudeTo = endCoordinates.lng;

    let theta = longitudeFrom - longitudeTo;
    let dist = Math.sin(deg2rad(latitudeFrom)) * Math.sin(deg2rad(latitudeTo))
        + Math.cos(deg2rad(latitudeFrom)) * Math.cos(deg2rad(latitudeTo)) * Math.cos(deg2rad(theta));
    dist = Math.acos(dist);
    dist = rad2deg(dist);
    let miles = dist * 60 * 1.1515;

    return miles * 1.609344;
}

// 弧度radian --> 角度degree
function rad2deg(r: number) {
    let degree = r * 180 / Math.PI;
    return degree;
}

// 角度degree --> 弧度radian
function deg2rad(degree: number) {
    let r = (degree / 180) * Math.PI;
    return r;
}
/**
 * 获取当前位置
 */
export async function GMapGetcurrentLocation() {
    // 是否禁用
    let disabledOrderBtn = false;

    // 拿到RBP 设置中的 餐厅地址和范围
    const SETTING = getCacheField('settingInfo');
    const map_key = _.find(SETTING, ['name', 'map_key'])?.value;
    const google_map_lat = _.find(SETTING, ['name', 'google_map_lat'])?.value;
    const google_map_lng = _.find(SETTING, ['name', 'google_map_lng'])?.value;
    const map_scope = _.find(SETTING, ['name', 'map_scope'])?.value;
    const set_map = _.find(SETTING, ['name', 'set_map'])?.value;
    console.log(google_map_lat, google_map_lng, map_scope, set_map);
    if (!(map_key && google_map_lat && google_map_lng && map_scope && set_map === 1)) {
        return disabledOrderBtn
    }
    // 获取当前位置
    if (navigator?.geolocation) {
        await new Promise<void>((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(async (position) => {
                let newlat = Number(position.coords.latitude)
                let newlng = Number(position.coords.longitude)
                const res = await checkAddress(
                    { google_map_lat, google_map_lng, setting_level_delivery_distance: map_scope },
                    [{
                        google_map_lat: newlat,
                        google_map_lng: newlng,
                    }]
                )
                console.log(res, res?.[0]?.isWithin);
                // 不在范围内，禁用点餐按钮
                disabledOrderBtn = res && res?.[0]?.isWithin === false;
                if (disabledOrderBtn) {
                    // MESSENGER
                    WebsocketClient.emit("MESSENGER", {
                        message: i18n.t('general_text_Getting_your_location_failed'),
                        level: 'Warning',
                    })
                }
                resolve();
            }, (error) => {
                console.log('map-error', error);
                // MESSENGER
                WebsocketClient.emit("MESSENGER", {
                    message: i18n.t('general_text_Getting_your_location_failed'),
                    level: 'Warning',
                })
                disabledOrderBtn = true;
                resolve();
            }, {
                enableHighAccuracy: true,
                timeout: 6000,
                maximumAge: 0
            });
        })
    } else {
        // MESSENGER
        WebsocketClient.emit("MESSENGER", {
            message: i18n.t('general_text_Getting_your_location_failed'),
            level: 'Warning',
        })
        disabledOrderBtn = true;
    }
    return disabledOrderBtn;
}


// **********
// Type
// **********

/**
 * 谷歌地图餐馆地址信息
 */
export interface GoogleMapRestaurant {
    google_map_lat?: number;
    google_map_lng?: number;
    setting_order_radius?: number;
    isWithin?: boolean;
    // TODO 配送距离单位：米
    setting_level_delivery_distance?: number;
}
/**
 * 用户地址
 *
 */
export interface UserAddress {
    google_map_lat?: number;
    google_map_lng?: number;
    isWithin?: boolean;
    line?: number;
}

// 经纬度
type coordinates = {
    lat: number,
    lng: number
}